import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-static';
import { Dispatch } from 'redux';

import { RootState } from '../../RootState';
import { changeLanguage, Language } from './localizationDuck';
import { RootAction } from '../../RootAction';

interface StateProps {
  language: Language;
}

interface DispatchProps {
  changeLanguage: (language: Language) => void;
}

interface LocalizationProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

class Localization extends React.Component<LocalizationProps> {
  constructor(props: LocalizationProps) {
    super(props);

    this.setLanguageFromPathname(props.location.pathname);
  }

  componentWillReceiveProps(nextProps: LocalizationProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setLanguageFromPathname(nextProps.location.pathname);
    }
  }

  shouldComponentUpdate(nextProps: LocalizationProps) {
    return nextProps.location.pathname !== this.props.location.pathname;
  }

  setLanguageFromPathname = (pathname: string) => {
    if (/^\/?cz(\/.*)?$/.test(pathname)) {
      this.props.changeLanguage('cz');
    } else {
      this.props.changeLanguage('en');
    }
  };

  render() {
    return (
      <div lang={/^\/?cz(\/.*)?$/.test(this.props.location.pathname) ? 'cs' : 'en'}>
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  changeLanguage: (language: Language) => dispatch(changeLanguage(language)),
});

export default withRouter(
  connect<StateProps, DispatchProps, {}, RootState>(
    mapStateToProps,
    mapDispatchToProps,
  )(Localization),
);



// WEBPACK FOOTER //
// /www/client/src/containers/Localization/Localization.tsx